import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemTextarea({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const title = fieldValue?.value_text || "-";
  return <ListItem preTitle={label ?? field.title} title={title} />;
}
